<template>
  <el-dialog
    :visible="visible"
    title="提示"
    width="1200"
    @open="open"
    @close="close"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <template #title
      ><i class="el-icon-warning text-warning me-2"></i>用户认购记录</template
    >

    <div class="d-flex justify-content-between mb-2">
      <el-form :model="formData" :inline="true" size="mini" ref="formRef">
        <el-form-item prop="userId">
          <el-input
            v-model="formData.userId"
            class="width-150"
            @keypress.enter="getTableData"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="formData.type"
            class="width-100"
            clearable
            @clear="getTableData"
            @change="getTableData"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option
              v-for="item in CurrentTreasureOrderType"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            class="ms-2"
            @click="getTableData"
            >确定</el-button
          >
        </el-form-item>
      </el-form>

      <!-- <div class="addon">
        <el-button
          type="primary"
          size="mini"
          @click="exportBtnClick"
        >
          :disabled="status.isSending || !canExport"
          导出
        </el-button>
      </div> -->
    </div>
    <el-table
      :data="tableData"
      size="mini"
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column
        property="userId"
        label="理财ID"
        sortable
      ></el-table-column>
      <el-table-column property="xtId" label="XT-ID" sortable></el-table-column>
      <el-table-column property="coinType" label="产品通证"></el-table-column>
      <el-table-column
        property="orderId"
        label="订单号"
        min-width="100"
      ></el-table-column>
      <el-table-column
        property="amount"
        label="订单数量"
        min-width="120"
        sortable
      >
        <template #default="scope">
          {{ thousandSeparator(scope.row.amount) }}
        </template>
      </el-table-column>
      <el-table-column
        property="totalIncome"
        label="总收益"
        min-width="150"
        sortable
      >
        <template #default="scope">
          {{ thousandSeparator(scope.row.totalIncome) }}
        </template>
      </el-table-column>
      <el-table-column
        property="nextIncome"
        label="预计下次收益"
        min-width="120"
        sortable
      >
        <template #default="scope">
          {{ thousandSeparator(scope.row.nextIncome) }}
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="100" sortable>
        <template #default="scope">
          <span>
            {{ scope.row.type === '1' ? '存入' : '[赎回' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        property="createTime"
        label="提交时间"
        width="180"
        sortable
      >
        <template #default="scope">
          <span>{{ dateFormat(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="年化收益" min-width="100" sortable align="right">
        <template #default="scope"> {{ scope.row.rate }}% </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  inheritAttrs: false,
  components: {},
  props: ['visible', 'currentId'],
  data() {
    return {
      tableData: [],
      formData: {
        userId: '',
        type: '',
        id: '',
      },
      isShowTypeSelector: true,

      CurrentTreasureOrderType: [
        {
          value: '1',
          label: '存入',
        },
        {
          value: '2',
          label: '赎回',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    ...mapActions('financial', ['getCurrentOrderList']),
    open() {
      this.formData.id = this.currentId
      const { data } = this.getCurrentOrderList({ id: this.currentId })
      this.tableData = data
    },
    close() {
      this.$refs['formRef'].resetFields()

      this.$emit('update:visible', false)
    },

    //重置
    getTableData() {
      this.getCurrentOrderList(this.formData)
    },
    handelConfirm() {
      this.$refs['formRef'].validate((valid) => {
        if (!valid) return

        this.close()
      })
    },
  },
}
</script>
